import type { DatalayerStreamSideEffect } from '@analytics/models';
import { InjectionToken, type Type } from '@angular/core';

/**
 * Token that holds all side-effects that can be triggered during the processing of the datalayer stream.
 */
export const DATALAYER_STREAM_SIDE_EFFECTS = new InjectionToken<
  DatalayerStreamSideEffect[]
>('DATALAYER_STREAM_SIDE_EFFECTS');

export function provideDatalayerSideEffects(
  sideEffects: Type<DatalayerStreamSideEffect>[]
) {
  return {
    provide: DATALAYER_STREAM_SIDE_EFFECTS,
    deps: sideEffects,
    useFactory: (...instances: DatalayerStreamSideEffect[]) => instances,
  };
}
